const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const StudioAddressBarcodeQueryURL = {
    GetStudioAddressBarcodes: Backofficebff + '/v1/AddressBarcodeDefinition/query-address-barcode-definition',
    GetStudioAddressBarcodesInformation:
        Backofficebff + '/v1/AddressBarcodeInformation/query-address-barcode-information',
};
